import { Environment } from "../environments/Environment";

export const msalConfig = {
  auth: {
    clientId: Environment.azureAppClientId,
    authority: Environment.azureAppAuthority,
    redirectUri: Environment.azureAppRedirectUri,
    postLogoutRedirectUri: Environment.azureAppPostLogoutRedirectUri
  },
};

export const loginRequest = {
  scopes: [ ...Environment.azureAppScopes.split(","), Environment.azureAppAPIScope ],
};

// For the sample API call
export const apiConfig = {
  scope: Environment.azureAppAPIScope,
};
